import { loadable } from '@owl-frontend/components';

export enum ShellRouteDefs {
  OwlShell = '/shell',
  Claims = '/shell/claims', // TODO: Remove in place of modal
  ClaimOverviewShell = '/shell/claim-details/:dossierId',
  ClaimOverviewShellTemplate = '/shell/claim-details/:dossierId/templates/:templateType',
  Inbox = '/shell/inbox',
  Broken = '/shell/uh-oh',
}

export const OwlShellContainer = loadable(
  () => import('../OwlShell/OwlShellContainer')
);

export const OwlShellInboxContainer = loadable(
  () =>
    import(
      '../OwlShell/components/OwlShellInboxContainer/OwlShellInboxContainer'
    )
);

export const ClaimOverviewShellContainer = loadable(
  () => import('./ClaimOverviewShellContainer')
);

export const ClaimOverviewShellLandingContainer = loadable(
  () =>
    import(
      './ClaimOverviewShellLandingContainer/ClaimOverviewShellLandingContainer'
    )
);

export const ClaimTemplateContainer = loadable(
  () => import('./ClaimTemplateContainer/ClaimTemplateContainer')
);
